import React from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import TwoColumnLayout from "./Layouts/TwoColumn";
import OneColumnLayout from "./Layouts/OneColumn";

const layouts = {
  "twocolumn": TwoColumnLayout,
  "onecolumn": OneColumnLayout,
};

export const ContactUsForm = ({ settings }) => {
  const { section, blocks } = settings;

  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint || 768);

  // Check render type to determine if component should be displayed
  if (section.render_type !== "all") {
    if (isMobile && section.render_type !== "mobile-only") return null;
    if (!isMobile && section.render_type !== "desktop-only") return null;
  }
  
  // Determine which layout to use based on settings and device
  const layoutType = isMobile ? section.layout_type_mobile || section.layout_type : section.layout_type;
  const Layout = layouts[layoutType] || TwoColumnLayout;

  // Sort blocks by their order settings
  let sortedBlocks = blocks;
  if (blocks) {
    if (isMobile) {
      // Sort blocks based on mobile sort order if available
      sortedBlocks = [...blocks].sort(
        (a, b) => (a.settings.sort_order_mobile || a.settings.sort_order) - 
                  (b.settings.sort_order_mobile || b.settings.sort_order),
      );
    } else {
      // Sort blocks based on desktop sort order
      sortedBlocks = [...blocks].sort(
        (a, b) => a.settings.sort_order - b.settings.sort_order,
      );
    }
  }

  return (
    <div
      className={`${section.reveal_animation_class || ""} relative`}
    >
      <div className={`relative w-full h-full text-${isMobile ? section.content_alignment_mobile : section.content_alignment_desktop}`}>
        <Layout 
          blocks={sortedBlocks} 
          settings={{
            ...settings,
            isMobile,
            mobile_breakpoint: settings.mobile_breakpoint || 768,
            section: {
              ...section,
              current_layout: layoutType,
            }
          }} 
        />
      </div>
    </div>
  );
};

export default ContactUsForm;
